export const documentTypeNames = {
    'title-plan': 'Title Plans',
    'title-register': 'Title Registers',
    'linked-documents': 'Filed Copies',
    'linked-documents-analysis': 'Filed Copies Analysis',
    'digital-mapping': 'Mapping & Highways',
    'planning': 'Planning Reports',
    'digital-title-plan': 'Mapping - Individual Title Plans',
    'companies-house': 'Corporate Crosschecks',
    'compiled-aerial-plan': 'Mapping - Aerial Compiled Plan',
    'compiled-digital-title-plan': 'Mapping - OS Compiled Plans',
    'upload': 'Uploaded',
    'ownership': 'Company Name',
    'lease': 'Leases',
    'search': 'Search',
    'analysed': 'Analysed',
    'scottish-title': 'Scottish Titles',
    'scottish-title-plan': 'Scotlis Title Plan',
    'scotlis': 'Scotlis',
    'scottish-app-enquiry': 'Scotlis App Enquiry',
    'scottish-burden-summary': 'Scotlis Burden Summary',
    'ros-title-number': 'Scotlis Title Number',
    'scottish-companies-house': 'Scotlis Companies House',
    'unknown': 'Unknown Documents',
    'epc': 'EPC Reports',
    'title-number': 'Title Number',
    'address': 'Address',
    'company-number': 'Company Number',
    'land-registry': 'Purchased',
    'scoping-compiled-aerial-plan': 'Mapping - Scoping Compiled Plan',
    'active-users': 'Active Users',
};

export const documentActionNames = {
    'documents': 'Documents Analysed',
    'purchases': 'Purchases',
    'scheduleOrders': 'Report Upgrades',
    'titleSearch': 'Title Searches',
    'activeUsers': 'Active Users',
    'topUsers': 'Top Users',
};
